var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNatification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21C13.2417 21 14.2489 19.9928 14.2489 18.75H9.75105C9.75105 19.9928 10.7583 21 12 21ZM19.5723 15.7368C18.8931 15.0069 17.6222 13.909 17.6222 10.3125C17.6222 7.58086 15.7069 5.39414 13.1243 4.85766V4.125C13.1243 3.50379 12.6209 3 12 3C11.3791 3 10.8757 3.50379 10.8757 4.125V4.85766C8.29312 5.39414 6.37781 7.58086 6.37781 10.3125C6.37781 13.909 5.10691 15.0069 4.42769 15.7368C4.21675 15.9635 4.12324 16.2346 4.12499 16.5C4.12886 17.0766 4.58132 17.625 5.25351 17.625H18.7465C19.4187 17.625 19.8715 17.0766 19.875 16.5C19.8768 16.2346 19.7832 15.9632 19.5723 15.7368Z",
    fill: "#242731"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNatification);
export default __webpack_public_path__ + "static/media/natification.341767b2b698e5d43fad5d274d154188.svg";
export { ForwardRef as ReactComponent };